<i *ngIf="!forMailRegister" class="fa" [ngClass]="{
  'fa-sort': sortOrder === 0,
  'fa-caret-down': sortOrder === 1,
  'fa-caret-up': sortOrder === 2
}" (click)="changeOrder()"></i>

<i *ngIf="forMailRegister" class="fa" [ngClass]="{
  'fa-sort hidden': sortOrder === 0,
  'fa-caret-down': sortOrder === 1,
  'fa-caret-up': sortOrder === 2
}"></i>